import React, { useState,} from "react";
import { StyleSheet, ScrollView, TouchableOpacity, Text } from 'react-native';

import { View } from '../../../components/Themed';
import Utilities from "../~Utilities/Utilities";
import { EvtData, FontInfo } from "../~Utilities/Constants";
import { Data } from "../~Utilities/Data";
import OBNakedText from "../C_Text/OBNakedText";
import OBChange from "../C_Text/OBChange";
import { ConnectionMkt } from "../~Utilities/Connection";
import { AntDesign, } from '@expo/vector-icons';
import { exp } from "react-native-reanimated";
import EVT from "./EVT";

/*   -------------------------------------------------------------------   */

const B_SETT_SMALL  = 30;
const SCROLL_DELTA  = 70;

/*   ---------------------------------------------------------------------   */

export interface IEVTTopInfo
{
  oData     : Data;
  oEVT      : EVT;
}

/*   ====================================================================   */

export default class EVTTop extends React.Component<IEVTTopInfo>
  {
  state = {visible: false};

  /*   -------------------------------------------------------------------   */

  private iScrollIndOvr : number              = 0;
  private oScrollRefOvr : ScrollView | any    = null;
  private oTimer        : NodeJS.Timer | null = null;

  private oLbls  : number[];
  private bOnce  : boolean  = false;
  private iTotal : number   = 0;

  /*   -------------------------------------------------------------------   */

  constructor(props)
  {
  super(props);

  this.state     = {visible: true};

  this.scrollTo          = this.scrollTo.bind(this);
  this.stopTimer         = this.stopTimer.bind(this);
  this.scrollSelected    = this.scrollSelected.bind(this);
  this.Refresh           = this.Refresh.bind(this);

  this.oLbls = new Array(this.props.oData.evt_exp? 
                         this.props.oData.evt_exp.length : 0)
  }

/*   ---------------------------------------------------------------------   */

componentWillUnmount()
{
this.stopTimer();
}

/*   ------------------------------------------------------------------   */

stopTimer()
{
if (this.oTimer)
  {
  clearInterval(this.oTimer);
  this.oTimer = null;
  }
}

/*   ---------------------------------------------------------------------   */

Refresh()
{
this.oLbls = new Array(this.props.oData.evt_exp? 
                        this.props.oData.evt_exp.length : 0)
this.forceUpdate();
}

/*   ---------------------------------------------------------------------   */

scrollTo(iDelta : number) 
{
if (iDelta < 0)
  {
  if (this.iScrollIndOvr <= 0)
    return;
  }

this.oScrollRefOvr?.scrollTo({x: this.iScrollIndOvr + iDelta, animated:true})

if (this.oTimer)
  return;
  //clearTimeout(this.oTimer);

this.oTimer = setInterval(this.scrollTo, 100, iDelta);
}

/*   -------------------------------------------------------------------   */

scrollSelected()
{
  if (this.props.oData.evt_index != undefined && this.bOnce == false && this.oLbls.length)
    {
    let iWidth = this.props.oData.evt_index < this.oLbls.length - 1? this.oLbls[this.props.oData.evt_index + 1] - this.oLbls[this.props.oData.evt_index] : 20;
    let iLeft  = 80 - iWidth/2;
    //this.oScrollRefOvr?.scrollTo({x: this.oLbls[this.state.ind_index], animated:false})
    this.oScrollRefOvr?.scrollTo({x: this.oLbls[this.props.oData.evt_index] - iLeft, animated:false})
    }

  this.bOnce = true;    
}

/*   -------------------------------------------------------------------   */

render()
{
if (!this.props.oData.evt_exp || this.props.oData.evt_exp.length <= 1)
  return(null);

  else return(
  // <View style={{marginVertical:0, alignItems:'center', justifyContent:'center',alignContent:'center', alignSelf:'center', marginTop:0, width:'100%', backgroundColor:'yellow'}}>
  <View style={{flexDirection:'row', alignItems:'center', alignSelf:'center', backgroundColor:'transparent', marginTop:2, }}>
  <TouchableOpacity style={this.props.oData.evt_exp.length <= 3? {display:'none'} : {marginHorizontal:5, marginTop:-6, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:'transparent',//'rgba(118,118,118,.5)', 
                                borderWidth:1}} 
                                onPressIn={ ()=>{this.scrollTo(-SCROLL_DELTA)} }
                                onPressOut= { ()=>{this.stopTimer()} }
                                >

  <AntDesign style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -1 }} name="left" size={18} color= {FontInfo.sDivider} />
  </TouchableOpacity>


  <ScrollView horizontal style={{minHeight:30, maxHeight:40, maxWidth:Utilities.WIDTH * 0.8 - 60,}} 
              // contentContainerStyle={{flexGrow:1, justifyContent:'center'}}
              contentContainerStyle={{backgroundColor:'transparent', flexGrow:1, alignItems:'center', justifyContent:'center'}}
              showsHorizontalScrollIndicator={false}
              scrollEventThrottle={0}
              
              ref={(node)=> this.oScrollRefOvr = node}
              onScroll={(event)=> this.iScrollIndOvr = event.nativeEvent.contentOffset.x}
              >
  <View style={{backgroundColor:'transparent', flexDirection:'row', alignItems:'center'}}>
      {
      this.props.oData.evt_exp?.map((oEvtData: EvtData, iIndex: number)=> 
      {
        return(
          <TouchableOpacity 
          key={iIndex}

          onLayout={(event) => {
                    this.oLbls[iIndex] = event.nativeEvent.layout.x;
                    this.iTotal++;

                    if (this.iTotal >= this.oLbls.length - 1)
                      {
                        this.scrollSelected();
                      }
                    }}

          style={{backgroundColor:'transparent', margin:4, alignItems:'center', borderBottomWidth:3,
                  borderBottomColor:iIndex == this.props.oData.evt_index? '#0096FF' : 'transparent'}}
              onPress={()=>
                {
                  if (this.props.oData.evt_index != iIndex)
                    {
                    this.props.oData.evt_index = iIndex;
                    this.props.oEVT.ChangeEVT(oEvtData);
                    }
                  //this.forceUpdate();
                  }}> 

          <Text style={[FontInfo.appStyles.txt_bold, {textAlign:'center', paddingHorizontal:1, paddingBottom:2, minWidth:0, color:FontInfo.sForeground}]}>{oEvtData.sExpiryDt}</Text>
          </TouchableOpacity>
      )})
      }


    </View>
    </ScrollView>

    <TouchableOpacity style={this.props.oData.evt_exp.length <= 3? {display:'none'} : {marginHorizontal:5, marginTop:-6, alignContent:'center', backgroundColor:'transparent', justifyContent:'center', 
                                padding:4, width:B_SETT_SMALL, height:B_SETT_SMALL, borderRadius:B_SETT_SMALL/2, borderColor:'transparent',//'rgba(118,118,118,.5)', 
                                borderWidth:1}} 
                                // onPressIn={()=>{this.oScrollRefOvr?.scrollTo({x: this.iScrollIndOvr + 10}); Utilities.Sendlog("pressed: " + Date.now());  }}>
                                onPressIn={ ()=>{this.scrollTo(SCROLL_DELTA)} }
                                onPressOut= { ()=>{this.stopTimer()} }
                                >

    <AntDesign style={{alignContent:'center', alignSelf:'center', textAlign:'center',  marginBottom: -1 }} name="right" size={18} color= {FontInfo.sDivider} />
  </TouchableOpacity>


  </View>

  // </View>
); 
}

/*   -------------------------------------------------------------------   */


}